// Safari Storage Access API handler
// Helps resolve cross-origin storage issues on iOS Safari

export async function requestStorageAccess(): Promise<boolean> {
  // Check if Storage Access API is available (Safari)
  // Type assertion since Storage Access API is defined in react-app-env.d.ts
  const doc = document as Document & {
    hasStorageAccess?: () => Promise<boolean>;
    requestStorageAccess?: () => Promise<void>;
  };

  if (!doc.hasStorageAccess || !doc.requestStorageAccess) {
    console.log('Storage Access API not available');
    return true; // API not available, assume access granted (non-Safari browsers)
  }

  try {
    // Check if we already have storage access
    const hasAccess = await doc.hasStorageAccess();
    
    if (hasAccess) {
      console.log('Storage access already granted');
      return true;
    }

    // Request storage access - this will prompt user on first interaction
    await doc.requestStorageAccess();
    console.log('Storage access granted by user');
    return true;
  } catch (error) {
    console.error('Storage access denied:', error);
    return false;
  }
}

// Check if we're running on Safari
export function isSafari(): boolean {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android');
}

// Wrapper to ensure storage operations work on Safari
export async function ensureStorageAccess(): Promise<boolean> {
  if (!isSafari()) {
    return true;
  }
  return requestStorageAccess();
}
